<template>
  <div>
    <mediaPlayer class="mediaPlay" :sourceUrl="sourceUrl" ref="mediaPlayer"></mediaPlayer>

    <div class="title"></div>
    <div class="pageTitle">详情介绍</div>

    <div class="theme">
      <div class="themeContent">
        <div class="themeTitle">直播主题</div>
        <p class="p1">科普进校园湾区百校行暨</p>
        <p class="p11">世界“腐蚀日”科普讲坛</p>
        <p class="p2">2022年4月24日</p>
        <p class="p3">4月24日是第14个“世界腐蚀日”，邀请防腐材料专家韩恩厚院长登台，培养青少年关注腐蚀、防控腐蚀的意识与责任。</p>
        <div class="table">
          <div class="leftup">16:05-16:35</div>
          <div class="rightup">防腐材料：韩恩厚院长演讲</div>
          <div class="leftdown">16:35-16:40</div>
          <div class="rightdown">腐蚀科普知识互动问答</div>
        </div>
      </div>
    </div>

    <div class="theme">
      <div class="themeContent2">
        <div class="themeTitle">直播讲师</div>
        <div class="laoshimain">
          <div class="toxian"></div>
          <div class="toxianinfo">
            <span class="name">韩恩厚</span>
<!--            <span class="name2"> x 防腐材料</span>-->
            <div class="name3">广东腐蚀科学与技术创新研究院院长</div>
          </div>
          <div class="laoshidetail">
            <p>
              {{ getinterduce }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="theme">
      <div class="themeContent3 clear-fix">
        <div class="themeTitle">组织单位</div>
        <div class="content3">
          <p>
            <span>指导单位：</span>
            {{ getzddw }}
          </p>
          <p>
            <span>主办单位：</span>
            {{ getzbdw }}
          </p>
          <p>
            <span>承办单位：</span>
            {{ getcbdw }}
          </p>
          <p>
            <span>支持单位：</span>
            {{ getjcdw }}
          </p>
          <p>
            <span>支持媒体：</span>
            人民日报、中国科学报、科技日报、南方日报、广东广播电视台、羊城晚报、嗨科普、黄埔区融媒体中心、南方+、中国科普博览、科普中国
          </p>
          <div style="width: 100%; height: 2rem"></div>
        </div>
      </div>
    </div>

    <div class="footer">

    </div>

  </div>
</template>

<script>
import mediaPlayer from "./mediaPlayer";

export default {
  name: "liveDetail",
  components:{
    mediaPlayer
  },
  props: {
    sourceUrl:{
      type: String,
      default: ''
    },
    baseInfo: {
      type: Object,
      required: true
    },
  },
  computed:{
    //老师简介
    getinterduce(){
      return this.baseInfo.finalVenue
    },
    //指导单位---活动简介
    getzddw(){
      return this.baseInfo.synopsis
    },
    //主办单位--活动流程
    getzbdw(){
      return this.baseInfo.process
    },
    //承办单位-视频内容规范
    getcbdw(){
      return this.baseInfo.videoStandard
    },
    //支持单位-视频评选标准
    getjcdw(){
      return this.baseInfo.videoCriteria
    }
  },
  methods:{
    resetLiveSourceUrl(url){
      console.log("lidetail set url:"+url)
      this.$refs.mediaPlayer.resetLiveSourceUrl(url)
    }
  }
}
</script>

<style scoped>
.mediaPlay{
  width: 100%;
  height: 613px;
}

.title{
  /*margin-top: ;*/
  width: 1080px;
  height: 797px;
  background-image: url("../../assets/live/live20220519_baner.jpg");
  background-repeat: no-repeat;
  background-size: 1080px 797px;
}
.pageTitle {
  height: 150px;
  background: #0089e1;
  font-size: 50px;
  font-weight: bolder;
  color: #fff;
  line-height: 150px;
  text-align: center;
}


.theme {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 100px;
}

.themeContent {
  width: 990px;
  height:865px;
  border-radius: 50px;
  border: 2px dashed #000;
  text-align: center;
  padding: 0 50px;
}
.themeContent .p1{
  margin-top: 75px;
  font-size: 50px;
  font-weight: bolder;
}
.themeContent .p11{
  margin-top: 30px;
  font-size: 50px;
  font-weight: bolder;
}
.themeContent .p2{
  font-size: 40px;
  margin-top: 30px;
}
.themeContent .p3{
  margin-top: 45px;
  margin-bottom: 45px;
  font-size: 40px;
  text-indent: 80px;
  text-align: left;
  line-height: 60px;
}

.themeTitle {
  width: 350px;
  height: 100px;
  border-radius: 20px;
  font-weight: bolder;
  font-size: 45px;
  color: #fff;
  background: #0089e1;
  margin-top: -50px;
  margin-left: 270px;
  line-height: 100px;
}


.table {
  margin-left: 25px;
  position: relative;
  width: 840px;
  height: 160px;
  background: #0c83ae;
  border-radius: 20px;
  font-size: 40px;
  color: white;
  text-align: center;
  line-height: 80px;
}
.table .leftup{
  position: absolute;
  top: 0px;
  left: 0px;
  border-bottom: 2px solid white;
  border-top-left-radius: 20px;
  height: 80px;
  width: 280px;
  background-color: #1f97c5;
}
.table .rightup{
  position: absolute;
  top:  0px;
  left: 282px;
  border-left: 2px solid white;
  border-bottom: 2px solid white;
  border-top-right-radius: 20px;
  height: 80px;
  width: 558px;
}
.table .leftdown{
  position: absolute;
  top: 80px;
  left: 0px;
  border-bottom-left-radius: 20px;
  height: 80px;
  width: 280px;
  background-color: #1f97c5;
}
.table .rightdown{
  position: absolute;
  top:  80px;
  left: 282px;
  border-left: 2px solid white;
  border-top-right-radius: 20px;
  height: 80px;
  width: 558px;
}

.themeContent2{
  position: relative;
  width: 990px;
  height:1450px;
  border-radius: 50px;
  border: 2px dashed #000;
  text-align: center;
  padding: 0 50px;
}

.laoshimain{
  position: absolute;
  top: 108px;
  left: 90px;
  width: 840px;
  height: 1180px;
  /*background-color: #ead287;*/
}

.laoshimain .toxian{
  position: absolute;
  top: 0px;
  left: 0px;
  width: 253px;
  height: 304px;
  /*background-image: url("../../assets/live/4.jpg");*/
  background-color: #666666;
  background-size: 253px 304px;
  background-repeat: no-repeat;
}

.laoshimain .toxianinfo{
  position: absolute;
  top: 50px;
  left: 350px;
  width: 460px;
  height: 254px;
  /*color: black;*/
  text-align: left;
  /*background-color: #790e0e;*/
}
.laoshimain .toxianinfo .name{
  font-size: 60px;
  font-weight: bolder;
  text-align: left;
  /*background-color: #ff5777;*/

}
.laoshimain .toxianinfo .name2{
  padding-left: 30px;
  font-size: 40px;
  font-weight: bolder;
}
.name3{
  margin-top:40px;
  font-size: 40px;
  font-weight: bolder;
  text-align: left;
}

.laoshidetail{
  position: absolute;
  top: 390px;
  left: 0px;
  width: 840px;
  height: 740px;
  /*color: black;*/
  font-size: 40px;
  text-indent: 80px;
  line-height: 65px;
  text-align: left;
}

.themeContent3 {
  width: 990px;
  /*height:1130px;*/
  border-radius: 50px;
  border: 2px dashed #000;
  text-align: center;
  padding: 0 50px;
}


.content3 {
  float: left;
  text-align: left;
  font-size: 40px;
  margin-top: 50px;
}

.content3 p {
  margin: 30px 0;
}

.content3 p span {
  font-weight: bolder
}

.footer {
  width: 100%;
  height: 200px;
  /*background: #1d398a;*/
}
</style>